module.exports = __webpack_public_path__ + "static/media/dsc_3755.5f4d8066.jpg";